import { useMutation } from '@tanstack/react-query';
import { projectCreation } from '@/enteties/project/api';
import { useState } from 'react';
import { useApiStatusToast } from 'shared/hooks/useApiStatusToast';
import { useServiceType } from 'widgets/project-creation-stepper/providers/service-provider';

export const useCreateApp = (onSuccess: () => void) => {
  const { setProjectSlug } = useServiceType();
  const [_, error] = useApiStatusToast();
  const [timedOut, setTimedOut] = useState(false);
  const mutation = useMutation({
    ...projectCreation.createProjectMutationOptions(),
    onMutate: () => {
      setTimedOut(true);
    },
    onSuccess: (data) => {
      setTimeout(async () => {
        onSuccess();
        setProjectSlug(data.slug);
        setTimedOut(false);
        // await queryClient.invalidateQueries({
        //   queryKey: projectKeys.allProjects,
        // });
      }, 3000);
    },
    onError: (e) => {
      setTimedOut(false);
      error({
        description: `${e.message}`,
      });
    },
  });

  return { timedOut, ...mutation };
};
